import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const stomachPolyps: AnswerPathTreeNode = {
  path: 'stomachPolyps',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredStomachPolypsDetails }],
};
